const state = {
  sidebarCollapsed: false,
  pageTitle: '',
  loginDialogVisible: false,
  changePasswordDialogVisible: false
}

const mutations = {
  TOGGLE_SIDEBAR(state) {
    state.sidebarCollapsed = !state.sidebarCollapsed
  },
  SET_PAGE_TITLE(state, title) {
    state.pageTitle = title
  },
  SHOW_LOGIN_DIALOG(state) {
    state.loginDialogVisible = true
  },
  HIDE_LOGIN_DIALOG(state) {
    state.loginDialogVisible = false
  },
  SHOW_CHANGE_PASSWORD_DIALOG(state) {
    state.changePasswordDialogVisible = true
  },
  HIDE_CHANGE_PASSWORD_DIALOG(state) {
    state.changePasswordDialogVisible = false
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
